/* eslint-disable react-hooks/exhaustive-deps */
import { CloudHuge, CloudSmall, CompanyInfo, Footer, Seagull, Ship, Wave } from '../../components';
import { $t } from '../../i18n';
import { useAnimation, useSensors, createParagraph, useScrollCounter2, useMediaQuery } from '../../utils';
import { animated, config } from '@react-spring/web'
import React, { useEffect, useState } from 'react';
import './Home.scss';
import animations from './animations.json';
import imageLogo from '../../assets/images/logo.svg';
import { COMPANY_ID, TRANSITION_DURATION } from '../../constants';

const COMPANY_STEP_MAP = {
	[COMPANY_ID.wave]: 2,
	[COMPANY_ID.track]: 2,
	[COMPANY_ID.techemy]: 3,
	[COMPANY_ID.propine]: 3,
	[COMPANY_ID.strix]: 4,
};

export const Home = function () {
	const [companyId, setCompanyId] = useState(null);
	const orientation = useSensors();

	const isMobile = useMediaQuery('(max-aspect-ratio: 4/4)');
	const animationStepsCount = isMobile ? 2 : 5;
	const [animationStep, setAnimationStep] = useScrollCounter2(0, 0, animationStepsCount, TRANSITION_DURATION);

	const styleScene = useAnimation(animationStep, animations.scene, config.molasses);
	const styleSceneMobile = useAnimation(animationStep, animations.sceneMobile, config.molasses);
	const styleCloudLeft = useAnimation(animationStep, animations.cloudLeft);
	const styleCloudRight = useAnimation(animationStep, animations.cloudRight);
	const styleIntro = useAnimation(animationStep, animations.intro);
	const styleIntroBody = useAnimation(animationStep, animations.introBody);
	const styleFinalBody = useAnimation(animationStep, animations.finalBody);
	const styleFinalBodyMobile = useAnimation(animationStep, animations.finalBodyMobile);
	const styleFooter = useAnimation(animationStep, animations.footer);

	const shipAngle = animationStep < 2
		? -Math.sign(orientation) * Math.sqrt(Math.abs(orientation))
		: 0;
	const isCaptainAnimated = !isMobile;
	const cloudsOffset = animationStep < 2 ? orientation : 0;

	const animateSeagull = animationStep === 1;
	const isIntroTitleShown = animationStep < 2;
	const isFirstSailActive = animationStep > 1;
	const isSecondSailActive = animationStep > 2 || (isMobile && animationStep > 1);
	const isThirdSailActive = animationStep > 3 || (isMobile && animationStep > 1);
	const isSailHoverAllowed = isFirstSailActive || (isMobile && animationStep === 2);
	const isSailClickAllowed = (isFirstSailActive && animationStep < 5) || (isMobile && animationStep === 2);

	const handleSailHover = (id) => {
		if (isMobile) {
			return;
		}
		if (isSailHoverAllowed) {
			setCompanyId(id);
		}
		else {
			setCompanyId(null);
		}
	}
	const handleSailClick = (id) => {
		if (isSailClickAllowed) {
			setCompanyId(id);
		}
		else {
			setAnimationStep(COMPANY_STEP_MAP[id]);
			setTimeout(() => {
				setCompanyId(id);
			}, TRANSITION_DURATION);
		}
	}


	useEffect(() => {
		if ((animationStep < 2 || animationStep > 4) && companyId !== null) {
			setCompanyId(null)
		}
	}, [animationStep]);

	return (
		<div className="home">
			<animated.div style={isMobile ? styleSceneMobile : styleScene} className="full-layer layer-scene">
				{!isMobile && <>
					<CloudSmall amplitude={50} distance={2} offset={cloudsOffset} type={0} className="layer-cloud-sm c-sm-1" />
					<CloudSmall amplitude={40} distance={2} offset={cloudsOffset} type={1} className="layer-cloud-sm c-sm-2" />
					<CloudSmall amplitude={35} distance={2} offset={cloudsOffset} type={2} className="layer-cloud-sm c-sm-3" />
					<CloudSmall amplitude={20} distance={2} offset={cloudsOffset} type={3} className="layer-cloud-sm c-sm-4" />
					<CloudSmall amplitude={5} distance={40} offset={cloudsOffset} type={4} className="layer-cloud-sm c-sm-5" />
					<CloudSmall amplitude={10} distance={40} offset={cloudsOffset} type={5} className="layer-cloud-sm c-sm-6" />
					<CloudSmall amplitude={10} distance={4} offset={cloudsOffset} type={6} className="layer-cloud-sm c-sm-7" />
					<CloudSmall amplitude={2} distance={60} offset={cloudsOffset} type={7} className="layer-cloud-sm c-sm-8" />
				</>}

				<CloudHuge type="left" style={styleCloudLeft} className="full-layer layer-cloud-left" />
				<CloudHuge type="right" style={styleCloudRight} className="full-layer layer-cloud-right" />
				{isIntroTitleShown && <div style={styleIntro} className="full-layer layer-intro">
					<div id="intro" className="intro">
						<img className="logo" src={imageLogo} alt="The Crow's Nest Logo" />
						<h1>{$t('intro_title')}</h1>
					</div>
				</div>}
				<Ship
					rotateTo={shipAngle}
					className="layer-ship"
					isCaptainAnimated={isCaptainAnimated}
					isFirstSailActive={isFirstSailActive}
					isSecondSailActive={isSecondSailActive}
					isThirdSailActive={isThirdSailActive}
					onCompanyClick={handleSailClick}
					onCompanyHover={handleSailHover}
				/>
				<Seagull animate={animateSeagull} position={[100, 60]} translateTo={[-500, -400]} type={0} className="seagull-1" />
				<Seagull animate={animateSeagull} position={[125, 80]} translateTo={[-600, -400]} type={1} className="seagull-2" />
				<Seagull animate={animateSeagull} position={[150, 100]} translateTo={[-700, -400]} type={2} className="seagull-3" />
				<Wave type={0} />
				<Wave type={1} />
				<Wave type={2} />
				<Wave type={3} />
				<div style={styleFooter}>
					<Footer />
				</div>
			</animated.div>
			<div style={styleIntroBody} className="layer-intro-body">
				<div className="intro-body">
					{createParagraph($t('intro_body'))}
				</div>
			</div>
			<div style={isMobile ? styleFinalBodyMobile : styleFinalBody} className="layer-final-body">
				<div className="intro-body">
					{createParagraph($t('final_body'))}
				</div>
			</div>
			<CompanyInfo isMobile={isMobile} companyId={companyId} className="layer-company-info" onClose={handleSailClick} />

			{/* preload images */}
			<img src={require('../../assets/images/modal/paper.png')} className="image-preload" />
			<img src={require('../../assets/images/modal/frame-black-side.png')} className="image-preload" />
			<img src={require('../../assets/images/modal/frame-black-middle.png')} className="image-preload" />
		</div>
	);
};
